import JStorageBackendList from './JStorageBackendList'

/* istanbul ignore next */
JStorageBackendList.install = function (Vue) {
  Vue.component(JStorageBackendList.name, JStorageBackendList)
}

export default JStorageBackendList
